import React, { useEffect, useState } from "react";
import './login.css';
import logo from '../../icon-1024.png'
import { ConversationAPI } from "../../apis/conversation/ConversationAPI";
import {ReactComponent as LindexLogo} from '../../logo.svg';

const Login = (props) => {
    const { setConversationId } = props;
    // User states
    const [storeId, setStoreId] = useState("");
    const [password, setPassword] = useState("");
    const [country, setCountry] = useState("");
    const [loading, setLoading] = useState(false);
    // Error states
    const [storeIdError, setStoreIdError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [requestError, setRequestError] = useState("");

    useEffect(() => {
        if (window.localStorage.getItem('password')) {
            setPassword(window.localStorage.getItem('password'));
        }
        if (window.localStorage.getItem('storeId')) {
            setStoreId(window.localStorage.getItem('storeId'));
        }
        if (window.localStorage.getItem('country')) {
            setCountry(window.localStorage.getItem('country'));
        }
    }, [])

    const onButtonClick = () => {
        setRequestError("");
        let hasError = false;
        setLoading(true);
        
        if (!validatePassword() && hasError !== true) {
            hasError = true;
        }
        if (!validateCountry() && hasError !== true) {
            hasError = true;
        }
        if (!validateStoreId() && hasError !== true) {
            hasError = true;
        }
        
        if (hasError) {
            setLoading(false);
            return;
        }

        ConversationAPI.startConversation()
            .then((id) => {
                setLoading(false);
                window.sessionStorage.setItem('conversationId', id);
                setConversationId(id);
            })
            .catch((error) => {
                if (error && error.response?.status === 401 ) {
                    setRequestError('Wrong password');
                    window.localStorage.removeItem('password');
                    setPassword('');
                } else {
                    setRequestError('Something went wrong, please try again or contact support')
                }
                setLoading(false);
            }
        );
    }

    const validatePassword = () => {
        if ("" === password || null === window.localStorage.getItem('password')) {
            setPasswordError("Please enter a password");
            return false;
        } else if (password !== window.localStorage.getItem('password')) {
            setPasswordError("Something went wrong, please re-enter password");
            return false;
        } else {
            setPasswordError("");
            return true;
        }
    }

    const validateCountry = () => {
        if ("" === country || null === window.localStorage.getItem('country')) {
            setCountryError("Please select country");
            return false;
        } else {
            setCountryError("");
            return true;
        }
    }
    const validateStoreId = () => {
        if("" === storeId) {
            setStoreIdError("Please enter store number");
            return false;
        }

        if (!/^\d+$/.test(storeId)) {
            setStoreIdError("Store number can only be numeric ex. 000");
            return false;
        } else if (storeId.length > 3) {
            setStoreIdError("Store number can't be longer then tree digits");
            return false;
        } else {
            setStoreId(storeId.padStart(3, '0'));
            window.localStorage.setItem('storeId', storeId.padStart(3, '0'))
            setStoreIdError("");
            return true;
        }
    }

    const addPassword = (value) => {
        window.localStorage.setItem('password', value);
        setPassword(value);

        if (value === '') {
            window.localStorage.removeItem('password');
        }
    }

    const addStoreId = (value) => {
        window.localStorage.setItem('storeId', value)
        setStoreId(value);

        if (value === '') {
            window.localStorage.removeItem('storeId')
        }
    }

    const addCountry = (value) => {
        window.localStorage.setItem('country', value)
        setCountry(value);

        if (value === '') {
            window.localStorage.removeItem('country')
        }
    }

    return <div className={"mainContainer"}>
        <div className={"imageContainer"}>
            <img className='login-logo' src={logo} alt="copilot logo" />
        </div>
        <div className={"titleContainer"}>
            <div>
                <LindexLogo></LindexLogo>
                <span>Copilot</span>
            </div>
        </div>
        <br />
        <div className={"inputContainer"}>
            <input
                value={password}
                placeholder="Enter your password here"
                onChange={ev => addPassword(ev.target.value)}
                className={"inputBox"}
                type="password" 
                name="password" />
            <label className="errorLabel">{passwordError}</label>
        </div>
        <div className={"inputContainer"}>
            <select
                value={country}
                onChange={ev => addCountry(ev.target.value)}
                className={"inputBox"}
            >
                <option value={''} >-- Choose Country --</option>
                <option>Sweden</option>
                <option>Norway</option>
                <option>Finland</option>
                <option>Estonia</option>
                <option>Lativa</option>
                <option>Lithuania</option>
                <option>Czech Republic</option>
                <option>Slovakia</option>
                <option>United Kingdom</option>
            </select>
            <label className="errorLabel">{countryError}</label>
        </div>
        <div className={"inputContainer"}>
            <input
                value={storeId}
                placeholder="Enter your store number, ex. 001"
                onChange={ev => addStoreId(ev.target.value)}
                className={"inputBox"} />
                <label className="errorLabel">{storeIdError}</label>
        </div>
        <br />
        <div className={"login inputContainer"}>
            <button
                className={"btn btn--primary"}
                type="button"
                onClick={onButtonClick}
                disabled={loading}
            >Log in</button>
            <label className="errorLabel">{requestError}</label>
        </div>
    </div>

}

export default Login;